import React from 'react';
import { useParams } from 'react-router-dom';

const PricingOption = ({ price, monthlySubscriptionAvailable = true, note, showHelpLink }) => {
  const { lang } = useParams();

  return (
    <div className="mt-8 text-center bg-white shadow-lg rounded-lg p-8">

      <div className='text-3xl font-semibold'>
        {monthlySubscriptionAvailable && (
          <>
            <div className="text-center text-2xl font-semibold text-gray-900 leading-[2]">
              <span className="relative mr-3 px-2 whitespace-nowrap">
                <span className="absolute -inset-1 block -skew-y-3 bg-sky-500" aria-hidden="true"></span>
                <span className="relative text-white">${price} USD</span>
              </span>
              per month or
              <span className="relative mx-3 px-2 whitespace-nowrap">
                <span className="absolute -inset-1 block -skew-y-3 bg-sky-500" aria-hidden="true"></span>
                <span className="relative text-white">${(price * 10)} USD</span>
              </span>
              if paid annually
            </div>
          </>
        )}
        {!monthlySubscriptionAvailable && (
          <>
            <div className="text-center text-2xl font-semibold text-gray-900">
              <span className="relative mr-3 px-2 whitespace-nowrap">
                <span className="absolute -inset-1 block -skew-y-3 bg-sky-500" aria-hidden="true"></span>
                <span className="relative text-white">${(price * 10)} USD</span>
              </span>
              per year
            </div>
          </>
        )}
      </div>

      <div className='my-6'>
        <p className="text-sm text-gray-600">
          <em>* License is per store. <a href={`/${lang}/terms-of-use`} className="text-blue-500 underline italic">Terms and conditions</a> apply.</em>
        </p>
        <p className="text-sm text-gray-600 italic mt-1">
          * 30 days free trial
        </p>
        {
          note && (
            <p className="text-sm text-gray-600 italic mt-1">
              {note}
            </p>
          )
        }
      </div>

      {
        showHelpLink &&
        <div>
          <a href='https://help.aronium.com/hc/en-us/articles/360017178700-How-to-buy-a-license' rel="noreferrer" title='How to buy a license?' target='_blank' className='button-rounded-white'>How to buy a license?</a>
        </div>
      }

    </div >
  );
};

export default PricingOption;
